/** Compatibility mount: meaningful content never waits for scroll observers. */
const ScrollReveals = () => null;

export default ScrollReveals;
